const toLayerValues = (value) => {
  if (value == null || value === '') return [];
  return (Array.isArray(value) ? value : [value]).map(String);
};

export const matchesPinnedSearchContext = (query = {}, pin) => {
  if (!pin?.productLayer) return false;

  const layers = toLayerValues(query.productLayer);
  const recordState = String(query.listingStatus || query.recordState || '').trim().toLowerCase();

  return layers.length === 1
    && layers[0] === String(pin.productLayer)
    && (recordState === 'draft' || recordState === 'has_draft');
};

export const resolvePinnedSearchIds = (query, pin) => {
  if (!pin?.ids?.length) return null;
  if (!matchesPinnedSearchContext(query, pin)) return null;
  return pin.ids;
};
